var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "go-pagination" }, [
    _c(
      "ul",
      [
        _c(
          "li",
          {
            staticClass: "page-item prev",
            class: { disabled: _vm.currentPage === 1 },
            on: {
              click: function ($event) {
                return _vm.onChangePage(_vm.currentPage - 1)
              },
            },
          },
          [_vm._m(0)]
        ),
        _vm._v(" "),
        _vm.startPage > 1
          ? _c(
              "li",
              {
                staticClass: "page-item",
                on: {
                  click: function ($event) {
                    return _vm.onChangePage(1)
                  },
                },
              },
              [_c("span", { staticClass: "page-link" }, [_vm._v("1")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.startPage > 2
          ? _c("li", { staticClass: "page-item disabled" }, [
              _c("span", { staticClass: "page-link" }, [_vm._v("...")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.visiblePages, function (page, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "page-item",
              class: { active: page === _vm.currentPage },
              on: {
                click: function ($event) {
                  return _vm.onChangePage(page)
                },
              },
            },
            [_c("span", { staticClass: "page-link" }, [_vm._v(_vm._s(page))])]
          )
        }),
        _vm._v(" "),
        _vm.endPage < _vm.totalPages - 1
          ? _c("li", { staticClass: "page-item disabled" }, [
              _c("span", { staticClass: "page-link" }, [_vm._v("...")]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.endPage < _vm.totalPages
          ? _c(
              "li",
              {
                key: _vm.endPage,
                staticClass: "page-item",
                on: {
                  click: function ($event) {
                    return _vm.onChangePage(_vm.totalPages)
                  },
                },
              },
              [
                _c("span", { staticClass: "page-link" }, [
                  _vm._v(_vm._s(_vm.totalPages)),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass: "page-item next",
            class: { disabled: _vm.currentPage === _vm.totalPages },
            on: {
              click: function ($event) {
                return _vm.onChangePage(_vm.currentPage + 1)
              },
            },
          },
          [_vm._m(1)]
        ),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "page-link", attrs: { "aria-label": "Previous" } },
      [_c("i", { staticClass: "go-icon-24 go-icon-chevron-left" })]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      { staticClass: "page-link", attrs: { "aria-label": "Next" } },
      [_c("i", { staticClass: "go-icon-24 go-icon-chevron-right" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }